export default "__VITE_ASSET__CVOGD3GT__"